import { SubmissionErrorBoundary } from '@/components/errors/SubmissionErrorBoundary';
import { TsForm } from '@/components/form/Form';
import { Button } from '@/components/shared/button/Button';
import { TSTitleCard } from '@/components/shared/card/Card';
import { RadioGroupField } from '@/components/shared/RadioGroup';
import { TableLoader } from '@/components/shared/table/TableLoader';
import {
  ReadEmployee,
  ReadRole,
  useGetRolesQuery
} from '@/services/gql/graphql.generated';
import { strings } from '@/services/translation/strings';
import { FC, Suspense } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { TSTitleCardStyle } from '../AddSingleTeamMemberForm';
import { roleSelectOptions } from '../overview/TeamFormCommon';
import { handleBEFormError } from '@/helpers/beFormErrorHelper';

interface FormProps {
  role: string;
}

export const TeamMemberPermissionsEditForm: FC<{ employee: ReadEmployee }> = ({ employee }) => {
  const methods = useForm<FormProps>({
    defaultValues: {
      role: employee.role
    }
  });

  // TODO: COMMENTING THIS OUT BECAUSE THE GQL ROLE UPDATE FUNCTION WAS REMOVED
  // const [{ fetching: updating }, updateRole] = useUpdateEmployeeRoleMutation();
  const updating = false;
  const handleError = useErrorHandler();

  const [{ data: roleData }] = useGetRolesQuery();
  const roles: ReadRole[] = roleData?.roles ?? [];

  const handleSubmit = async (data: FormProps) => {
    const roleId = roles.find(role => role.name === data.role)?.id;

    if (!roleId) {
      handleError(new Error(strings.permissions.invalidSelectedRole));
      return;
    }

    try {
      // TODO: REIMPLEMENT WHEN WE HAVE A PROPER FUNCTION TO UPDATE ROLES IN GQL
      // IT MIGHT JUST BE THE NORMAL EMPLOYEE UPDATE
      // const result = await updateRole({
      //   roleId,
      //   userId: employee.identityId
      // });

      // if (result.error) {
      //   throw result.error;
      // } else {
      //   goBack();
      // }
    } catch (ex: any) {
      handleBEFormError(ex, methods);
    }
  };

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  return (
    <TsForm methods={methods} onSubmit={handleSubmit}>
      <TSTitleCard title={strings.timeshift.teamMember.permissions.edit} className={TSTitleCardStyle}>
        <SubmissionErrorBoundary>
          <Suspense fallback={<TableLoader />}>
            <div className="flex flex-col gap-4">
              <RadioGroupField
                id="role"
                className="w-full"
                fieldSetClasses={`flex flex-col md:flex-row md:flex-wrap space-y-4 md:space-y-0 focus:bg-red-500 whitespace-nowrap`}
                labelClasses={'border rounded-md'}
                name="role"
                title={strings.common.role}
                label={strings.common.role}
                required
                validationMessage={strings.common.mandatory(strings.common.role)}
                noOptionsString={strings.timeshift.teamMember.permissions.noRolesAvailable}
                items={roleSelectOptions(roles)}
              />
            </div>
          </Suspense>
        </SubmissionErrorBoundary>
      </TSTitleCard>
      <div className="space-y-5 max-w-3xl mx-auto mb-4pt-5 pl-5">
        <div className="flex w-full items-center justify-end gap-5">
          <Button onClick={goBack}>{strings.common.cancel}</Button>
          <Button primary type="submit" loading={updating}>
            {strings.common.save}
          </Button>
        </div>
      </div>
    </TsForm>
  );
};
